import { Outlet, Navigate } from "react-router-dom";

const DesignerRoutes = (props) => {
   return props.designer ? <Outlet /> : <Navigate to="/" />;
};

export default DesignerRoutes;
